import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getFirebaseEnv } from '@/config/env';

let app: FirebaseApp | undefined;

/**
 * Singleton de Firebase App.
 * Se inicializa bajo demanda para no fallar en rutas que aún no usan Firebase.
 */
export function getFirebaseApp(): FirebaseApp {
  if (!app) {
    app = initializeApp(getFirebaseEnv());
  }
  return app;
}
